import { nutritionFormAdapter } from "../form-adapter";
export const fruitNutritionAdapter = nutritionFormAdapter("fruit");
